import React, { useCallback } from 'react';
import { FlexibleCol, Row } from '@yme/atoms/grid';
import { CardForEvents } from '@yme/molecules/cards/card-for-events';
import { getCardCaption } from '@yme/organisms/news-events-grid/helpers';
import { DigitalDataMutation, buildKey, setDigitalData } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { NoResultsPage } from './NoResultsPage';
import { NEWS_TYPE, EVENTS_TYPE } from './constants';
export function GridContent({ articlesData, articles, labels, isLoaded, isRightToLeft, language, commonLabels, gridType, }) {
    const { common_readMore_link: readMoreLabel } = commonLabels;
    const cardForEventCallback = useCallback((link) => () => {
        if (articlesData) {
            const id = link
                .split('/')
                .filter((item) => item)
                .slice(-2)
                .join('/');
            if (gridType === NEWS_TYPE) {
                setDigitalData(DigitalDataMutation.NEWS_ITEM_CLICK, {
                    articleResponse: articlesData,
                    id,
                });
            }
            if (gridType === EVENTS_TYPE) {
                setDigitalData(DigitalDataMutation.EVENTS_ITEM_CLICK, {
                    articleResponse: articlesData,
                    id,
                });
            }
        }
    }, [articlesData, gridType]);
    const cards = articles?.length ? (articles.map((article, index) => {
        const { image, title, description, link, eventLogo, countryFlag, locationTitle } = article;
        const caption = getCardCaption(article, language);
        return (React.createElement(FlexibleCol, { key: buildKey(article.title, index), lg: 4, md: 6 },
            React.createElement(CardForEvents, { callback: cardForEventCallback(link), isRightToLeft: isRightToLeft, cardProps: {
                    image,
                    title,
                    description,
                    link,
                    labelLink: readMoreLabel,
                    caption,
                    additionalCaption: locationTitle,
                    aspectRatio: AspectRatio.RectangleLevel3,
                    eventLogo,
                    flag: countryFlag,
                    countLineVisible: 'initial',
                    marginBottom: articles?.length ? '56px' : '0',
                    isFullHeaderVisible: true,
                } })));
    })) : (React.createElement(NoResultsPage, { gridType: gridType, isLoaded: isLoaded, labels: labels }));
    return React.createElement(Row, null, cards);
}
GridContent.displayName = 'GridContent_Organism';
